const TermsPage = () => {
  return (
    <div className="min-h-screen bg-background pt-24 px-4 lg:px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-foreground mb-6">
          Terms of Service
        </h1>

        <div className="nex-card p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">
              1. Acceptance of Terms
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              By accessing or using BUYFIAT services, you agree to be bound by
              these Terms of Service. If you do not agree to these terms, you
              may not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">
              2. Eligibility
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              You must be at least 18 years old and have the legal capacity to
              enter into binding contracts. By using our services, you represent
              and warrant that you meet these requirements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">
              3. Account Registration
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities that occur under your
              account. You agree to notify us immediately of any unauthorized
              use of your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">
              4. Trading Risks
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Cryptocurrency trading involves significant risk. You acknowledge
              that you understand these risks and are solely responsible for
              your trading decisions. BUYFIAT is not responsible for any losses
              incurred through trading activities.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">
              5. Prohibited Activities
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              You agree not to engage in any illegal activities, market
              manipulation, money laundering, or any other activities that
              violate applicable laws and regulations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">
              6. Limitation of Liability
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              To the maximum extent permitted by law, BUYFIAT shall not be
              liable for any indirect, incidental, special, consequential, or
              punitive damages arising out of or relating to your use of our
              services.
            </p>
          </section>

          <p className="text-sm text-muted-foreground pt-4 border-t border-border">
            Last updated: December 2024
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
